import { Difficulty } from './words';

export interface HistoryEntry {
  id: string;
  date: number;
  wpm: number;
  rawWpm: number;
  accuracy: number;
  timeMode: number;
  difficulty: Difficulty;
  correct: number;
  incorrect: number;
  extra: number;
}

const STORAGE_KEY = 'cryotype_history';
const MAX_ENTRIES = 20;

export function loadHistory(): HistoryEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as HistoryEntry[]) : [];
  } catch {
    return [];
  }
}

export function saveHistoryEntry(entry: Omit<HistoryEntry, 'id'>): void {
  try {
    const history = loadHistory();
    const newEntry: HistoryEntry = { ...entry, id: `${Date.now()}-${Math.random().toString(36).slice(2)}` };
    const updated = [newEntry, ...history].slice(0, MAX_ENTRIES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // Silently fail if localStorage is unavailable
  }
}

export function clearHistory(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function formatDate(timestamp: number): string {
  const d = new Date(timestamp);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}
